import { render } from "./DialogTermsConditions.vue?vue&type=template&id=0f5eb067"
import script from "./DialogTermsConditions.vue?vue&type=script&lang=js"
export * from "./DialogTermsConditions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__